// extracted by mini-css-extract-plugin
module.exports = {"ContactParent":"Contact_styles_ContactParent__3ERdV","ContactHead":"Contact_styles_ContactHead__1vUg0","ContactParagraph":"Contact_styles_ContactParagraph__xkCxN"};